import { useStore, DOC_KEY } from '@/state/store';
import { TOOLS, TOOL_ORDER } from '@/tools/registry';

export function StatusBar() {
  const tool = useStore((s) => s.tool);
  const doc = useStore((s) => s[DOC_KEY[s.tool]]);
  const canvas = useStore((s) => s.project.canvas);
  const busy = useStore((s) => s.ui.busy);

  const size =
    tool === 'collage'
      ? `${canvas.width} × ${canvas.height} · ${canvas.aspect}`
      : tool === 'splitter'
        ? 'tiles export at 1080 px'
        : 'strip cut into slides';

  return (
    <footer className="panel z-10 flex h-7 shrink-0 items-center justify-between px-3 text-[12px] text-[var(--text-tertiary)] hairline-t">
      <span className="shrink-0 font-mono tabular-nums">{TOOLS[tool].status(doc)}</span>
      <span className="truncate px-2">{busy}</span>
      <span className="hidden shrink-0 font-mono tabular-nums sm:inline">{size}</span>

      {/* The only navigation the studio has — it links the other tools' pages
          from the rendered DOM, not just from the served HTML. */}
      <nav className="ml-3 hidden shrink-0 items-center gap-3 md:flex" aria-label="Site">
        {TOOL_ORDER.filter((id) => id !== tool).map((id) => (
          <a
            key={id}
            className="rounded-[4px] underline-offset-2 hover:text-[var(--text-primary)] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]"
            href={TOOLS[id].path}
          >
            {TOOLS[id].label}
          </a>
        ))}
        <a className="rounded-[4px] underline-offset-2 hover:text-[var(--text-primary)] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]" href="/guide">
          Guide
        </a>
        <a className="rounded-[4px] underline-offset-2 hover:text-[var(--text-primary)] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]" href="/privacy">
          Privacy
        </a>
      </nav>
    </footer>
  );
}
